import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { DisplayButton } from '@xo-union/tk-ui-links';
import InlineErrorMessage from '~/glm/components/shared/inline-error-message';
import UserStore from '~/glm/models/user-store';
import AnalyticsStore from '~/glm/models/analytics-store';
import styles from './page-header-errors.scss';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import GdsUiState from '~/glm/models/gds/gds-ui-state';

@withRouter
@inject('analyticsStore', 'userStore', 'gdsUiState')
@observer
class PageHeaderErrors extends Component {
  componentWillUnmount() {
    const { event } = this.props;
    if (event) event.resetRsvpErrors();
  }

  goToWwsDashboard = () => {
    this.props.analyticsStore.track('Dashboard Interaction', { action: 'wws dashboard' }, {}, () =>
      window.location.assign('/gs/dashboard')
    );
  };

  goToRsvpSettings = () => {
    const { gdsUiState, analyticsStore, history } = this.props;
    gdsUiState.setRsvpSettingsView(true);
    history.push('/our-guest-list/rsvp-settings');
    analyticsStore.track('Dashboard Interaction', {
      action: 'rsvp settings',
    });
  };

  enableRsvp = () => {
    const { event, analyticsStore } = this.props;
    analyticsStore.track('Dashboard Interaction', {
      action: 'enable rsvp',
      userDecisionArea: 'rsvp banner',
    });
    this.dismissEnableRsvpAlert();
    event.setProp('rsvp', true);
  };

  dismissEnableRsvpAlert = () => {
    const { userStore, event } = this.props;
    userStore.setDismissRSVPEnabledAlert(event.id);
  };

  render() {
    const { event, userStore } = this.props;

    if (event.getActiveRsvpErrors.length > 0) {
      const errorType = event.getActiveRsvpErrors[0];
      return (
        <InlineErrorMessage
          fullWidth={true}
          className={styles.error}
          type={'error'}
          onDismiss={() => event.setRsvpError(errorType, false)}
        >
          {event.rsvpErrorMessages(errorType)}
        </InlineErrorMessage>
      );
    } else if (event.rsvp && userStore.needsPublicAlert) {
      return (
        <InlineErrorMessage type={'error'}>
          Your privacy setting is PUBLIC, which means anyone can RSVP even if they are not invited.&nbsp;
          <DisplayButton color="primary" onClick={this.goToRsvpSettings}>
            Update your RSVP settings!
          </DisplayButton>
        </InlineErrorMessage>
      );
    } else if (event.rsvp && userStore.needsSpellingAlert) {
      //hide this alert when zero state is shown
      return (
        <InlineErrorMessage type={'warning'} onDismiss={() => userStore.setDismissedSpellingAlert()}>
          Guests can now RSVP via your site! Check below to make sure that you&apos;ve added everyone.
        </InlineErrorMessage>
      );
    } else if (event.rsvp && userStore.needsWwsNotPublishedAlert) {
      return (
        <InlineErrorMessage type={'warning'} onDismiss={() => userStore.setDismissedWwsNotPublishedAlert()}>
          Heads-up: Your RSVP settings will be saved, but guests can&rsquo;t RSVP yet since your website is unpublished.
          For more info, visit your site&rsquo;s&nbsp;
          <DisplayButton color="primary" onClick={this.goToWwsDashboard}>
            dashboard
          </DisplayButton>
          .
        </InlineErrorMessage>
      );
    } else if (
      !event.rsvp &&
      event.guestCount > 20 &&
      event.rsvpCoverage < 50 &&
      userStore.getNeedsRSVPEnabledAlert(event.id)
    ) {
      return (
        <InlineErrorMessage className={styles.error} type={'warning'} onDismiss={this.dismissEnableRsvpAlert}>
          Heads up! RSVP is off for this event. Turn it on so guests can RSVP via your website.
          <DisplayButton color="primary" onClick={this.enableRsvp}>
            {' '}
            Turn RSVP On
          </DisplayButton>
          .
        </InlineErrorMessage>
      );
    }
    return null;
  }
}

PageHeaderErrors.propTypes = {
  event: PropTypes.instanceOf(GdsEventModel).isRequired,
  userStore: PropTypes.instanceOf(UserStore),
  analyticsStore: PropTypes.instanceOf(AnalyticsStore),
  gdsUiState: PropTypes.instanceOf(GdsUiState),
};

export default PageHeaderErrors;
